import PropTypes from "prop-types";
import Movie from "./Movie";
import MoviesLoading from "../MoviesLoading/MoviesLoading";

Movies.propTypes = {
  loading: PropTypes.bool,
  movies: PropTypes.array,
};

export default function Movies(props) {
  const { movies, loading } = props;

  if (loading) {
    return <MoviesLoading />;
  }

  if (!movies.length) {
    return (
      <div className="billboard-movies">
        <h2>
          No hay funciones disponibles para tu selección. Intenta con otra fecha
          u horario.
        </h2>
      </div>
    );
  }

  return (
    <div className="billboard-movies">
      {movies.map((movie) => (
        <Movie movie={movie} key={movie.id} />
      ))}
    </div>
  );
}
